import { useState, useEffect, useRef, useContext } from "react";
import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';

import authAxios from "../../components/authAxios";

import { useNavigate } from "react-router-dom";
import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

import moment from 'moment';    

import { Steps, Button } from 'antd';
// import { Input, Select, Space } from 'antd';


import NumberFormat from 'react-number-format';

import App, {UserContext} from "../../App"
import UserAlerts from "../../components/UserAlerts";
import DashboardHeader from "../../components/DashboardHeader";
import useDebounce from "../../components/useDebounce";
import ApplicationGuarantors from "./ApplicationGuarantors";

import './Loans.css'
import ApplicantFinancials from "./ApplicantFinancials";
import LoanSecurity from "./LoanSecurity";
// import Loan from "./Loan";

function ApplicationNew() {
    const [error, setError] = useState('');
    const errorRef = useRef(null);
    const queryClient = useQueryClient();
    const pageSize = useContext(UserContext).page_size;

    const user = localStorage.getItem('userID');
    const client = localStorage.getItem('clientID');

    const [searchText, setSearchText] = useState('');
    const debouncedSearchText = useDebounce(searchText, 500);

    const [isModalOpen, setIsModalOpen] = useState(false);
    

    // const addGtrLine = (newGtrLine) => {
    //     setGtrLines([...gtrLines, newGtrLine]);
    //     setIsModalOpen(false); // Close the modal after adding the expense
    // };

    const { data: customers, isFetching, isLoading } = useQuery({ // IMPORTANT NOTE: Different use cases for isFetching and isLoading
        queryKey: ['customers', debouncedSearchText],
        queryFn: async () => {
            const response = await authAxios.get("/crm/customer-contacts", {params: {search: debouncedSearchText}});
            return response.data
        },
        enabled: !!debouncedSearchText.trim(),
        keepPreviousData: true,
        initialData: []
    });

    const { data: products } = useQuery({
        queryKey: ['products'],
        queryFn: async () => {            
            const response = await authAxios.get(`/inventory/items/?&page_size=${pageSize}`);
            return response.data.results;
        },
    });

    const termUnits = [
        {
            value: 'DAYS',
            label: 'Days',
        },
        {
            value: 'WEEKS',
            label: 'Weeks',
        },
        {
            value: 'MONTHS',
            label: 'Months',
        },
        {
            value: 'YEARS',
            label: 'Years',
        },
    ];

    const repaymentFrquencies = [
        {
            value: 'DAILY',
            label: 'Daily',
        },
        {
            value: 'WEEKLY',
            label: 'Weekly',
        },
        {
            value: 'MONTHLY',
            label: 'Monthly',
        },
    ];


    const navigate = useNavigate();

    // const [customer, setCustomer] = useState(null);
    const [applicant, setApplicant] = useState(null);

    const [product, setProduct] = useState(null);
    const [loanAmount, setLoanAmount] = useState('');
    const [memo, setMemo] = useState('');

    const [termUnit, setTermUnit] = useState(termUnits[2]); // Default to 'Months'
    const [repaymentFrequency, setRepaymentFrequency] = useState(repaymentFrquencies[2]); // Default to 'Monthly'
    const [term, setTerm] = useState(''); 
    const [txnLines, setTxnLines] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [guarantors, setGuarantors] = useState([]);
    const [loanSecurities, setLoanSecurities] = useState([]);
    const [loanDocs, setLoanDocs] = useState([]);

    // IMPORTANT: Initialise select, dates as null to avoid undefined errors
    const [applicationDate, setApplicationDate] = useState(null);
    const [firstPaymentDate, setFirstPaymentDate] = useState(null);

    const contactRef = useRef("");
    contactRef.showContactType=true   

    const addTxnLine = (newTxnLine) => {
        setTxnLines([...txnLines, newTxnLine]);
        setIsModalOpen(false); // Close the modal after adding the expense
    };

    // const addTableData = (newRowData) => {
    //     setTableData([...tableData, newRowData]);
    //     setIsModalOpen(false); // Close the modal after adding the expense
    // };

    const addGuarantor = (newGuarantor) => {
        setTableData([...tableData, newGuarantor]);
        setIsModalOpen(false); // Close the modal after adding the expense
    };

    const addSecurity = (newSecurity) => {
        setLoanSecurities([...loanSecurities, newSecurity]);
        setIsModalOpen(false); // Close the modal after adding the expense
    };


    const isStepValid = () => {
        if (currentStep === 0) {
            return applicant !== null;
        }
      
        if (currentStep === 1) {
            return product !== null && term>0 && termUnit && repaymentFrequency && applicationDate;
        }
      
        if (currentStep === 2) {
            return txnLines.length > 0;
        }

        if (currentStep === 3 || currentStep ===4) {
            return true;
        }
      
        return false;
    };

    const { Step } = Steps;
    const [currentStep, setCurrentStep] = useState(0);

    const nextStep = () => {
    setCurrentStep(currentStep + 1);
    };

    const prevStep = () => {
    setCurrentStep(currentStep - 1);
    };

    const mutation = useMutation({
        // mutationFn: (application) => {
        //     return authAxios.post("/loans/loan-applications/", application);
        // },
        mutationFn: (applicationFormData) => {
            return authAxios.post("/loans/loan-applications/", applicationFormData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        },
        onError: (error, variables, context) => {
            if (error.response.data.error){
                // If it's an array, display each error message
                if (Array.isArray(error.response.data.error)) {
                    error.response.data.error.map((errorMessage) => (
                        setError(errorMessage)
                    ));
                } else {
                    // Handle single error message
                    setError(error.response.data.error); 
                }
            } else {
                // Fallback to Standard error message
                setError(error.message); 
            }      
        },
        onSuccess: (result) => {
            queryClient.invalidateQueries(['applications']);
            navigate('/dashboard/applications/')
        },
    })


    const handleSubmit = (e) => {
        e.preventDefault();

        const customer = applicant.id
        const amount = parseFloat(loanAmount.replace(/,/g, ''));
        const date = applicationDate
        const first_payment_date = firstPaymentDate
        const term_unit = termUnit.value
        const repayment_frequency = repaymentFrequency.value
        const cashflow_entries = txnLines
        const guarantors = tableData
        const loan_securities = loanSecurities

        // const application = {client, customer, product, amount, date, first_payment_date, term, term_unit, repayment_frequency, cashflow_entries, guarantors, loan_securities, user};
        const formData = new FormData();
        formData.append('client', client);
        formData.append('customer', customer);
        formData.append('product', product);
        formData.append('amount', amount);
        formData.append('date', date);
        formData.append('first_payment_date', first_payment_date);
        formData.append('term', term);
        formData.append('term_unit', term_unit);
        formData.append('repayment_frequency', repayment_frequency);
        formData.append('user', user);
        formData.append('memo', memo);
        
        formData.append('cashflow_entries', JSON.stringify(
            cashflow_entries.map(({ description, amount, frequency, category }) => ({
            description,
            amount,
            frequency,
            category,
            }))
        ));

        formData.append('guarantors', JSON.stringify(
            guarantors.map(({ id, name, phone, amount }) => ({
            id,
            name,
            phone,
            amount,
            }))
        ));

        formData.append('loan_securities', JSON.stringify(
            loan_securities.map(({ security_type, name, category, value, memo }) => ({
            security_type,
            name,
            category,
            value,
            memo
            }))
        ));

        // Combine docs + photo
        const allDocs = [...loanDocs];

        formData.append('loan_docs_metadata', JSON.stringify(
            allDocs.map(({ document_type, document_number }) => ({
            document_type,
            document_number,
            // issue_date,
            // expiry_date,
            }))
        ));

        allDocs.forEach(doc => formData.append('loan_docs_files', doc.file));

        console.log(formData)
        mutation.mutate(formData)
    }

    useEffect(()=>{
        if (error){
            errorRef.current.scrollIntoView();  
        }            
    },[error])

    // console.log("LOAN DOCS", loanDocs)

    return(
        <div className="dashboard-main">
            <section className="dashboard-content">
                <section className="dashboard-form dashboard-form-compact">
                    <div ref={errorRef}>
                        <UserAlerts error={error}  />
                    </div>
                    <DashboardHeader dashboardTitle="New Application" dashboardPreTitle="Loans" />

                    <div className="property-new-steps">

                        <Steps size="small" current={currentStep}>
                            <Step title="Applicant" />
                            <Step title="Loan Details" />
                            <Step title="Financials" />
                            <Step title="Guarantors" />
                            <Step disabled={true} title="Security" />
                            {/* <Step disabled={true} title="Documents" /> */}
                        </Steps>

                        <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                            {currentStep === 0 && (
                            <>
                                <Autocomplete
                                    value={applicant}
                                    onChange={(event, newValue) => setApplicant(newValue)}
                                    inputValue={searchText}
                                    onInputChange={(event, newInput) => setSearchText(newInput)}
                                    options={customers || []}
                                    getOptionLabel={(option) => { return option ? option.name : '' }} // Ensure option is not null or undefined
                                    isOptionEqualToValue={(option, value) => //IMPORTANT: This is the magic
                                        option.id === value.id
                                    }

                                    noOptionsText={
                                        searchText.trim().length < 1
                                            ? 'Enter search text'
                                            : isFetching
                                            ? 'Loading…'
                                            : 'No matches found. Please try a different search'
                                    }
                                    renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Customer" />}
                                />

                                <TextField className="custom-input"
                                    value={applicant?applicant.address:""}
                                    label="Physical Address" 
                                    variant="outlined" 
                                    fullWidth
                                    disabled
                                />  

                                <TextField className="custom-input"
                                    value={applicant?applicant.city:""}
                                    label="City/Town" 
                                    variant="outlined" 
                                    fullWidth
                                    // required
                                    // error={cityError}
                                    disabled
                                />  
                            
                            </>
                            )}

                            {currentStep === 1 && (
                            <>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        setProduct(newValue.sku_id);
                                    }}
                                    options={products || []}
                                    getOptionLabel={(option) => { return option ? option.name : '' }} // Ensure option is not null or undefined
                                    renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Loan Product" />}
                                />

                                <NumberFormat   
                                    value={loanAmount}
                                    onChange={(e) => setLoanAmount(e.target.value)}
                                    className="custom-input"
                                    fullWidth
                                    label="Amount" 
                                    variant="outlined" 
                                    customInput={TextField}
                                    suffix=""
                                    decimalScale={2}
                                    fixedDecimalScale
                                    decimalSeparator="."
                                    allowNegative={false}
                                    isNumericString
                                    thousandSeparator={true} 
                                />

                                <div className="three-columns">
                                    <NumberFormat   
                                        value={term}
                                        onChange={(e) => setTerm(e.target.value)}
                                        className="custom-input"
                                        fullWidth
                                        label="Term" 
                                        variant="outlined" 
                                        customInput={TextField}
                                        suffix=""
                                        allowNegative={false}
                                        isNumericString
                                        thousandSeparator={true} 
                                    />

                                    <Autocomplete
                                        value={termUnit}
                                        onChange={(event, newValue) => {
                                            setTermUnit(newValue);
                                            console.log("VALUE", newValue)
                                            }}
                                        options={termUnits}

                                        // getOptionLabel={(option) => option.name}
                                        getOptionLabel={(option) => option?.label || ""}
                                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                        renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Term Units"  /> }
                                    />

                                    <Autocomplete
                                        value={repaymentFrequency}
                                        onChange={(event, newValue) => {
                                            setRepaymentFrequency(newValue);
                                            console.log("VALUE", newValue)
                                            }}
                                        options={repaymentFrquencies}
                                        getOptionLabel={(option) => option?.label || ""}
                                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                        renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Repayment Frequency"  /> }
                                    />
                                </div>

                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                    <DesktopDatePicker
                                        value={applicationDate}
                                        label="Application Date"
                                        inputFormat="DD-MM-YYYY" 
                                        onChange={(newDate) => {
                                            setApplicationDate(moment(newDate).format("YYYY-MM-DD"));
                                        }}
                                        error={!applicationDate}
                                        helperText={!applicationDate ? "Application date is required" : ""} 
                                        renderInput={(params) => <TextField fullWidth required className="custom-input" {...params} />}
                                    />
                                </LocalizationProvider>
                            </>
                            )}
                            
                            {currentStep === 2 && (
                            <>
                                <ApplicantFinancials 
                                    addTxnLine={addTxnLine}
                                    txnLines={txnLines} 
                                    setTxnLines={setTxnLines} 
                                    isModalOpen={isModalOpen}
                                    setIsModalOpen={setIsModalOpen}
                                />
                            </>
                            )}
                            
                            {currentStep === 3 && (
                            <>
                                <ApplicationGuarantors 
                                    // addTableData={addTableData}
                                    // tableData={tableData} 
                                    // setTableData={setTableData} 
                                    addGuarantor={addGuarantor}
                                    tableData={tableData} 
                                    setTableData={setTableData} 
                                    isModalOpen={isModalOpen}
                                    setIsModalOpen={setIsModalOpen}
                                />
                            </>
                            )}

                            {currentStep === 4 && (
                            <>
                                <LoanSecurity 
                                    addSecurity={addSecurity}
                                    loanSecurities={loanSecurities} 
                                    setLoanSecurities={setLoanSecurities} 
                                    isModalOpen={isModalOpen}
                                    setIsModalOpen={setIsModalOpen}
                                    setLoanDocs={setLoanDocs}
                                />
                            </>
                            )}

                            <div className="button-border-top">
                                {currentStep > 0 && (
                                    <Button type="default" onClick={prevStep}>
                                        Previous
                                    </Button>
                                )}
                                {currentStep < 4 && (
                                    <Button type="primary" onClick={nextStep} disabled={!isStepValid()}>
                                        Next
                                    </Button>
                                )}
                                {currentStep === 4 && (
                                    <Button 
                                        type="primary" 
                                        htmlType="submit" 
                                        disabled={!isStepValid()}
                                        loading={mutation.isLoading}
                                    >
                                        Save
                                    </Button>    
                                )}
                        
                            </div>
                        </form> 
                    </div>
                </section>
            </section> 

        </div>

    )   
}


export default ApplicationNew;
